export default __webpack_public_path__ + "static/media/livestream-OBS-dummy.3adb5caa.png";